import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiUser, CreateUserRequest, QueryUsersParams, UpdateUserRequest } from '@core/models/api/user.model';

@Injectable({
  providedIn: 'root'
})
export class UsersApiService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/users`;

  getAll(query?: QueryUsersParams): Observable<ApiUser[]> {
    let params = new HttpParams();
    if (query?.search) {
      params = params.set('search', query.search);
    }
    if (query?.role) {
      params = params.set('role', query.role);
    }
    return this.http.get<ApiUser[]>(this.baseUrl, { params });
  }

  getMe(): Observable<ApiUser> {
    return this.http.get<ApiUser>(`${this.baseUrl}/me`);
  }

  getById(id: string): Observable<ApiUser> {
    return this.http.get<ApiUser>(`${this.baseUrl}/${id}`);
  }

  create(payload: CreateUserRequest): Observable<ApiUser> {
    return this.http.post<ApiUser>(this.baseUrl, payload);
  }

  update(id: string, payload: UpdateUserRequest): Observable<ApiUser> {
    return this.http.patch<ApiUser>(`${this.baseUrl}/${id}`, payload);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
